import Clap from "modules/emoji/assets/emoji_clap.png";
import Like from "modules/emoji/assets/emoji_thumbs.png";
import Confused from "modules/emoji/assets/emoji_monocle.png";

export const REACTIONS_CONTAINER_ID = "reactions-container";

export const IMAGE_URL_BY_REACTION_TYPE = {
  clap: Clap,
  like: Like,
  confused: Confused,
};

export const FLOATING_REACTION_IMAGE_SIZE = 18;

export const MAX_SIMULTANEOUS_FLOATING_REACTIONS = 20;

export const FLOATING_REACTION_DURATION = 3800;

export const FLOATING_REACTION_INTERVAL =
  FLOATING_REACTION_DURATION / MAX_SIMULTANEOUS_FLOATING_REACTIONS;

export const MAX_SIMULTANEOUS_AUDIENCE_VIEW_REACTIONS = 20;

export const AUDIENCE_VIEW_REACTION_INTERVAL = (1000 / 60) * 10;
